// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .page-title {
      margin-bottom: 20px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/analytics/analytics-parent.component.ts"],"names":[],"mappings":";IACI;MACE,mBAAmB;IACrB","sourcesContent":["\n    .page-title {\n      margin-bottom: 20px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
